"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledBadgedAvatar = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _BadgedAvatarMixin = require("../../mixins/components/BadgedAvatarMixin");
var StyledBadgedAvatar = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "StyledBadgedAvatar",
  componentId: "c11n-8-107-0__sc-1d1a27i-0"
})(["", ""], _BadgedAvatarMixin.BadgedAvatarMixin);
exports.StyledBadgedAvatar = StyledBadgedAvatar;